import React from "react"
import { FaFacebookSquare } from "react-icons/fa"

const data = [
  {
    id: 1,
    icon: <FaFacebookSquare className="social-icon"></FaFacebookSquare>,
    url: "https://www.facebook.com/MM-Tischlerei-106100201919094/",
  },
]

export default data
